'use client';

import { FC } from 'react';
import Button from '~/components/button';
import Socials from '~/components/socials';
import CommonData from '~/data/strapi/types/single-types/common-data';
import { YMGoal, useMetrika } from '~/providers/ya-metrica';
import emailHref from '~/utils/email-href';
import phoneHref from '~/utils/phone-href';

import styles from './styles.module.css';

interface Props {
  commonData: CommonData;
  onCallClick: () => void;
}

const BurgerContacts: FC<Props> = ({ commonData, onCallClick }) => {
  const phone = commonData.phone;
  const email = commonData.email;
  const socials = commonData.socialContacts;

  const { captureGoal } = useMetrika();

  const onPhoneClick = () => {
    captureGoal(YMGoal.NUMBER_CLICK);
  };

  const onEmailClick = () => {
    captureGoal(YMGoal.EMAIL_CLICK);
  };

  return (
    <div className={styles.container}>
      {phone && (
        <a onClick={onPhoneClick} href={phoneHref(phone)} target="_blank" rel="noreferrer" className={styles.phoneLink}>
          {phone}
        </a>
      )}

      {email && (
        <a onClick={onEmailClick} href={emailHref(email)} target="_blank" rel="noreferrer" className={styles.phoneLink}>
          {email}
        </a>
      )}

      {socials && <Socials data={socials} containerClassName={styles.socials} iconClassName={styles.socialIcon} />}

      <Button className={styles.button} title="Заказать звонок" onClick={onCallClick} />
    </div>
  );
};

export default BurgerContacts;
